import { CertificationType } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import _ from 'lodash';
import { useMemo } from 'react';
const sortCertificationsChronological = (cert1, cert2) => {
  return new Date(cert2.createdDate).getTime() - new Date(cert1.createdDate).getTime();
};
export const useGroupedAccountCertifications = _ref => {
  let {
    accountCertifications
  } = _ref;
  const groupedCertificationResults = useMemo(() => {
    if (!accountCertifications || _.isEmpty(accountCertifications)) {
      return {};
    }
    accountCertifications.sort(sortCertificationsChronological);
    const groupedCertifications = accountCertifications.reduce((accum, current) => {
      if (!current?.certificationType) {
        return accum;
      }
      const certificationGroup = CertificationTypeToGroupMap?.[current.certificationType];
      const certificationType = certificationGroup ?? current.certificationType;
      const entryForType = accum[certificationType];
      if (Array.isArray(entryForType)) {
        accum[certificationType].push(current);
      } else {
        accum[certificationType] = [current];
      }
      return accum;
    }, {});
    const mostRecentOfEachGroup = Object.entries(groupedCertifications).map(_ref2 => {
      let [key, certsForGroup] = _ref2;
      const mostRecentForGroup = certsForGroup[0];
      const entry = {
        groupType: key,
        createdDate: mostRecentForGroup?.createdDate
      };
      return entry;
    });
    const sortedCertificationTypes = mostRecentOfEachGroup.sort(sortCertificationsChronological);
    const certificationGroups = Object.keys(groupedCertifications);
    return {
      sortedCertificationTypes,
      groupedCertifications,
      certificationGroups
    };
  }, [accountCertifications]);
  return {
    ...groupedCertificationResults
  };
};
const CertificationGroups = ['DEVELOPER', 'DESIGNER'];
const CertificationsWithGroups = [CertificationType.STUDIO_DEVELOPER, CertificationType.STUDIO_DEV_WEBSITES_LEAGUE, CertificationType.STUDIO_DESIGN_LEAGUE, CertificationType.WEB_DESIGNER];
const CertificationTypeToGroupMap = {
  [CertificationType.STUDIO_DEVELOPER]: 'DEVELOPER',
  [CertificationType.STUDIO_DEV_WEBSITES_LEAGUE]: 'DEVELOPER',
  [CertificationType.STUDIO_DESIGN_LEAGUE]: 'DESIGNER',
  [CertificationType.WEB_DESIGNER]: 'DESIGNER'
};
//# sourceMappingURL=useGroupedAccountCertifications.js.map